<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="popup-named-router">
  <div class="popup-content">
    <button pButton icon="fa-solid fa-xmark" class="p-button-rounded p-button-text p-button-lg close" (click)="close()" data-testid="close-btn"></button>

    <router-outlet></router-outlet>
  </div>
</div>


